export { useAlarmControlView, type UseAlarmControlViewInput } from "./useAlarmControlView";
export {
  useAlarmControlDispatch,
  type UseAlarmControlDispatchInput,
  type AlarmControlDispatchResult,
} from "./useAlarmControlDispatch";
